<div class="gitem-card">

  <div class="gitem-char">
    <ng-container *ngIf="langTgtSrv.current.code !== 'ja'">
      {{ grapheme.value }}
    </ng-container>
    <ng-container *ngIf="langTgtSrv.current.code === 'ja'">
      {{ type === 'katakana' ? grapheme.katakana : grapheme.hiragana }}
    </ng-container>
  </div>

  <div class="gitem-phonetics" *ngIf="langTgtSrv.current.displayPhonetic && grapheme.phonetics">
    {{ grapheme.phonetics }}
  </div>

  <div class="gitem-audios" *ngIf="grapheme.audio || grapheme.phonemes?.length">
    <button
      type="button"
      class="gitem-audio-btn"
      *ngIf="grapheme.audio && !grapheme.phonemes"
      (click)="audioSrv.play(grapheme.audio)">
      <i class="fa-solid fa-volume-high"></i>
    </button>
    <ng-container *ngIf="grapheme.phonemes">
      <button
        type="button"
        class="gitem-audio-btn"
        *ngFor="let phoneme of grapheme.phonemes; trackBy: trackByIndex"
        [disabled]="!phoneme.audio"
        (click)="phoneme.audio && audioSrv.play(phoneme.audio)">
        <i class="fa-solid fa-volume-high"></i>
      </button>
    </ng-container>
  </div>

</div>
